"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Promptable;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _devLogger = _interopRequireDefault(require("react-utils/devLogger"));

var _RootNode = require("../utils/RootNode");

var _UIFullScreen = _interopRequireDefault(require("../dialog/UIFullScreen"));

/**
 * @param  {React.Component}
 * @param  {HTMLElement}
 * @param  {?Object}
 * @param  {?React.Component} parentComponent - ReactComponent instance
 * @return {Promise}
 */
function doPrompt(Component, contextRootNode, additionalProps, parentComponent) {
  var element = document.createElement('div');

  var promiseCallback = function promiseCallback(resolve, reject) {
    var WrappedComponent = _react.default.createElement(_UIFullScreen.default, {
      "data-layer-for": "Promptable",
      rootNode: contextRootNode
    }, _react.default.createElement(Component, (0, _extends2.default)({}, additionalProps, {
      onConfirm: resolve,
      onReject: reject
    })));

    if (parentComponent) {
      _reactDom.default.unstable_renderSubtreeIntoContainer(parentComponent, WrappedComponent, element);
    } else {
      _reactDom.default.render(WrappedComponent, element);
    }
  }; // Maintain backward compatibility in apps that expect a Q promise


  var promise = window.Q ? new window.Q.Promise(promiseCallback) : new Promise(promiseCallback);
  return promise.finally(function () {
    _reactDom.default.unmountComponentAtNode(element);
  });
}
/**
 * @param  {React.Component}
 * @param  {HTMLElement}
 * @return {(additionalProps: ?Object) => Promise}
 */


function Promptable(Component) {
  var contextRootNode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, _RootNode.getDefaultNode)();

  _devLogger.default.warn({
    message: 'Promptable: The `Promptable` function is deprecated. Try mounting `UIModal` directly.',
    url: 'https://git.hubteam.com/HubSpot/UIComponents/issues/7435',
    key: 'promptable-deprecation'
  });

  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return doPrompt.apply(void 0, [Component, contextRootNode].concat(args));
  };
}

module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3722/js/decorators/Promptable.js
// module id = 318
// module chunks = 5 6